export default __webpack_public_path__ + "static/farid-shabanov-0834022af1a40dbb4da7f5d9d1333fa5.png";